module.exports = __webpack_public_path__ + "img/texiao-_0000s_0014_15.9880ee6a.png";